import { useRef, useState, type ChangeEvent } from 'react';
import { prepareChatImage, type PreparedChatImage } from '../../../utils/chat-image';

export const usePendingImage = ({
  setErrorMessage,
}: {
  setErrorMessage: (message: string | null) => void;
}) => {
  const [pendingImage, setPendingImage] = useState<PreparedChatImage | null>(null);
  const [isPreparingImage, setIsPreparingImage] = useState(false);
  const imageInputRef = useRef<HTMLInputElement | null>(null);

  const handleImageFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    setIsPreparingImage(true);
    try {
      const prepared = await prepareChatImage(file);
      setPendingImage(prepared);
      setErrorMessage(null);
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : 'Kunde inte läsa bilden.');
    } finally {
      setIsPreparingImage(false);
    }
  };

  return { pendingImage, setPendingImage, isPreparingImage, imageInputRef, handleImageFileChange };
};
